import axios from 'axios';

async function downloadFromS3(data) {
  if (data.s3Download) {
    const awsAxios = axios.create({
      transformRequest: (dataAws, headers) => {
        delete headers.common.Authorization;
      },
    });

    data = await awsAxios.get(data.signedS3URL)
      .then(s3Response => s3Response.data);
  }

  return Promise.resolve(data);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  downloadFromS3,
};



// WEBPACK FOOTER //
// ./src/helpers/axiosS3Downloader.js